import React from "react";
import "./style.css";
export default function LineSeparator({ style }) {
  return <div className="line-separator" style={style} />;
}
